import { gql } from "@apollo/client";
/** 
 * SUBSCRIPTIONS
*/

export const GET_DATA_OBSERVATIONS = gql`
  subscription OnChangesSince($since: timestamp!) {
    observations(
      where: { date_creation: { _gte: $since } }
    ) {
      id
      shape_last_position
      shape
      date_creation
      phone_create_date
      phone_update_date
      nom_bateau
      en_cours
      description
      objectid
      bateau_id
    }
  }
`;

/** 
 * QUERIES
*/

// Query initiale : TOUT l'historique 
export const GET_ALL_OBSERVATIONS = gql`
  query GetAllObservations {
    observations(
    where: {
        date_creation: { _gte: "2026-01-01", _lt: "2027-01-01" }
      }
      order_by: { date_creation: asc }
    ) {
      id
      shape_last_position
      shape
      date_creation
      phone_create_date
      phone_update_date
      nom_bateau
      en_cours
      description
      objectid
      bateau_id
    }
  }
`;



export const GET_USERS = gql`
  query getUsers {
    users {
      id
      email
      defaultRole
      disabled
    }
  }
`;

export const GET_BOATS = gql`
query getBoats {
  bateaux {
    id
    nom_bateau
    code_pf
  }
}
`;

export const GET_ROLES = gql`
  query getRoles {
    authRoles {
      role
    }
  }
`;

export const GET_USER_BOAT = gql`
  query getBoatUser {
    users_bateaux {
      user_id
      bateau_id
    }
  }
`;

/** 
 * MUTATIONS
*/

export const UPDATE_USER_STATUS = gql`
  mutation UpdateUserStatus($email: citext!, $disabled: Boolean!) {
    updateUsers(
      where: { email: { _eq: $email } }
      _set: { disabled: $disabled }
    ) {
      affected_rows
    }
  }
`;


export const ADD_USER = gql`
  mutation AddUser($email: citext!, $role: String!) {
    insertUser(
      object: {
        email: $email
        emailVerified: true
        locale: "fr"
        roles: { data: { role: $role } }
      }
    ) {
      id
    }
  }
`;

export const ADD_BOAT = gql`
  mutation AddBoat($name: String!, $codePf : String!) {
    insert_bateaux_one(
      object: {
        nom_bateau: $name
        code_pf: $codePf
      }
    ) {
      id
    }
  }
`;

export const ASSIGN_BOAT = gql`
 mutation AssignBoats($boats: [users_bateaux_insert_input!]!) {
    insert_users_bateaux(objects: $boats) {
      returning {
        user_id
        bateau_id
      }
    }
  }
`;


export const DISMISS_BOAT = gql`
 mutation DissmissBoats($boats: [users_bateaux_bool_exp!]!) {
    delete_users_bateaux(where: { _or: $boats }) {
      returning {
        user_id
        bateau_id
      }
    }
  }
`;